module.exports = __webpack_public_path__ + "static/img/advantage.a05904f3.png";